interface ToMergeAsNamesParams {
  firstNames: string; // 'Carlos Eduardo' or 'Carlos'
  lastNames?: string; // 'Silva Santos' or 'Silva' or '' or undefined
}

export function toMergeAsBasicName(params: ToMergeAsNamesParams): string {
  const { firstNames, lastNames = '' } = params;
  const first = firstNames.trim();
  const last = (lastNames ?? '').trim();
  let basicName = first.split(' ')[0];
  const mainLastName = last.split(' ')[0]?.[0];
  basicName += mainLastName ? ` ${mainLastName.toUpperCase()}` : '';
  // last trim remove first space when exists only lastName
  return basicName.trim();
}

export function toMergeAsFullName(params: ToMergeAsNamesParams): string {
  const { firstNames, lastNames = '' } = params;
  const first = firstNames.trim();
  const last = (lastNames ?? '').trim();
  let fullName = first;
  if (last) fullName += ` ${last}`;
  // last trim remove first space when exists only lastName
  return fullName.trim();
}
